import React from 'react';
import styled from 'styled-components';

import { IconButton, TextField } from '@mui/material';
import { useTheme } from '../../../styles';
import { DeleteOutlineOutlined } from '@mui/icons-material';

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  gap: 8px;
`;

interface Props {
  id: string;
  value: string;
  updateMediaUrl: (value: string) => void;
  deleteMediaUrl: (id: string) => void;
  disabled: boolean;
}

export const MediaParameter: React.FC<Props> = ({ id, value, updateMediaUrl, deleteMediaUrl, disabled }) => {
  const theme = useTheme();

  return (
    <Container>
      <TextField
        variant='outlined'
        value={value}
        onChange={(e) => updateMediaUrl(e.target.value)}
        placeholder='URL'
        disabled={disabled}
        fullWidth
      />
      <IconButton
        disabled={disabled}
        sx={{
          border: `1px solid ${theme.line.light}`,
          height: '52px',
          width: '52px',
        }}
        onClick={() => deleteMediaUrl(id)}
      >
        <DeleteOutlineOutlined sx={{ fontSize: '1.6ch', color: theme.text.subtext }} />
      </IconButton>
    </Container>
  );
};
